<template>
  <div >
    <div
      v-if="isResignedUser"
      class="resigned-banner"
      style="background-color: #ff4d4d; color: white; padding: 5px; text-align: center;"
    >
      You are currently serving your notice period. Please ensure strict
      adherence to company policies.
      <router-link
        to="/policies"
        style="color: white; text-decoration: underline;"
      >
        Click here to review the policies.
      </router-link>
    </div>
    <div v-if="$root.isImpersonating && $root.impersonatedUser" class="resigned-banner"
      style="background-color: #f59e0b; color: #ffffff; padding: 5px; display: flex; justify-content: space-between; align-items: center; padding-right: 19px; padding-left: 15px;">
        <span>You are logged in as {{ $root.impersonatedUser.email }}.</span>
        <p v-if="$root.isImpersonating" @click="logoutAsEmployee" style="text-transform: uppercase; cursor: pointer; font-size: smaller; display: none; margin-bottom: 0px;" class="large-screen-text">Log out as Employee</p>
        <i v-if="$root.isImpersonating" @click="logoutAsEmployee" class="fa fa-sign-out-alt mobile-icons" color="gray" style="font-size: 18px; display: none; cursor: pointer;"></i>
    </div>
    <nav class="navbar navbar-toggleable-md bg-white">
      <div class="container" ref="menuWrapper">
        <!-- <button
          type="button"
          class="navbar-toggler navbar-toggler-right"
          data-toggle="collapse"
          data-target="#navigation"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click="() => console.log('Navbar toggler clicked')"
        >
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
        </button> -->
        <!-- <button type="button" class="navbar-toggler navbar-toggler-right" @click="mobileMenuOpen = !mobileMenuOpen"
          style="margin-right: -20px;">
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
        </button> -->
        <span style="position: absolute; right: -5px; top: 1.5px; z-index: 1000; display: none; align-items: center; gap: 10px;" class="mobile-icons">
          <NotificationBell v-if="currentUserId" :userId="currentUserId" />
          <button class="notif-bell"
            :class="{ 'notif-bell--active': isPanelOpen && !isMobile, 'notif-bell--no-hover': isMobile }"
            @click="logout" aria-label="Notifications">
            <i class="fa fa-sign-out-alt" color="gray" style="font-size: 18px;"></i>
          </button>
        </span>
        <div class="navbar-minimize">
          <button
            type="button"
            class="navbar-toggler"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
          <!-- <div v-if="mobileMenuOpen" class="mobile-menu-dropdown">
            <div class="mobile-menu-item" @click="logout">
              <i class="fa fa-sign-out-alt" style="font-size: 18px;"></i>
              <span>Log out</span>
            </div>
          </div> -->
        </div>
        <div class="navbar-brand" v-if="$route">{{ routeName }}</div>
        <div class="collapse navbar-collapse justify-content-end" id="navigation">
          <ul class="navbar-nav">
          <!-- <li class="nav-item">
            <a class="nav-link" href="#">
              <p class="hidden-lg hidden-md">Account</p>
            </a>
          </li> -->
          <!-- <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <p>Dropdown</p>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" href="#">Action</a>
              <a class="dropdown-item" href="#">Another action</a>
              <a class="dropdown-item" href="#">Something else here</a>
            </div>
          </li> -->

            <li class="nav-item" style=" display:flex ; justify-content: end;">
              <NotificationBell v-if="currentUserId" :userId="currentUserId" />
            </li>

          <li class="nav-item" style=" display:flex ; justify-content: end;">
              <a class="nav-link" href="javascript:function() { return false; }" @click="logout">
                <p class="">Log out</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import firebase from "../../../assets/config/firebase";
import sw from "sweetalert";
import { unloadChatbot } from "../../../utils/chatbotLoader";
import NotificationBell from "./NotificationBell.vue";
import { requestNotificationPermission } from "../../../services/notificationService";

export default {
  components: {
    NotificationBell,
  },
  computed: {
    impersonatedUserEmail() {
      const user = localStorage.getItem('impersonateUser');
      return user ? JSON.parse(user).email : '';
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isResignedUser() {
      const currentUser = this.$store.state.auth.user;
      return currentUser.status === "Resigned";
    },
    isImpersonating() {
      return this.$root.isImpersonating;
    },
    currentUserId() {
      if (this.isImpersonatingLocal) { // use reactive flag instead of localStorage directly
        try {
          const impersonated = localStorage.getItem("impersonateUser");
          return impersonated ? JSON.parse(impersonated).uid || null : null;
        } catch (e) {
          return null;
        }
      }
      return this.$store.state.auth.user.uid || null;
    },
  },
  data() {
    return {
      activeNotifications: false,
      mobileMenuOpen: false,
      isImpersonatingLocal: !!localStorage.getItem('impersonateUser'), // add this
    };
  },
  watch: {
    '$route'() {
      console.log('Route changed to:', this.$route.name);
      this.checkResignedStatus();
      this.$forceUpdate();
    },
    '$store.state.auth.user': {
      handler(newUser) {
        console.log('Auth user changed:', newUser);
        this.$forceUpdate();
      },
      deep: true
    }
  },
  async created() {
    const user = localStorage.getItem('impersonateUser');

    this.$root.isImpersonating = !!user;
    this.$root.impersonatedUser = user ? JSON.parse(user) : null;

    await requestNotificationPermission();
  },
  mounted() {
    this.checkResignedStatus();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      const menu = this.$refs.menuWrapper;

      if (menu && !menu.contains(event.target)) {
        this.mobileMenuOpen = false;
      }
    },
    logoutAsEmployee() {
      localStorage.removeItem('impersonateUser');
      this.$root.isImpersonating = false;
      this.$root.impersonatedUser = null;
      this.isImpersonatingLocal = false;
      this.againLoginAsAdmin();
      if (this.$route.path === '/usermanagement') {
        this.$router.push('/overview');
      } else {
        this.$router.push('/usermanagement');
      }
    },
    async againLoginAsAdmin() {
      var routeUserId = localStorage.getItem('originalAdminUser') ? JSON.parse(localStorage.getItem('originalAdminUser')).uid : null;

      try {
        await this.$store.dispatch('initializeAuth');
        var userData;
        if (routeUserId) {
          userData = await firebase.getSingleUser(routeUserId);
          if (!userData) {
            throw new Error('User not found');
          }
        } else {
          userData = this.$store.state.auth.user || defaultUserData;
        }

        const user = {
          ...userData,
          bankName: userData.bankName || '',
          email: userData.email || '',
          iban: userData.iban || '',
          isActive: userData.isActive !== undefined ? userData.isActive : true,
          joiningDate: userData.joiningDate || '',
          leavesAllowed: userData.leavesAllowed || 7.5,
          leavesAvailable: userData.leavesAvailable || 15,
          leavesTaken: userData.leavesTaken || '',
          nicNumber: userData.nicNumber || '',
          phoneNumber: userData.phoneNumber || '',
          role: userData.role || '',
          salary: userData.salary || 0,
          twitterProfile: userData.twitterProfile || '',
          uid: routeUserId || userData.uid || (this.$store.state.auth.user ? this.$store.state.auth.user.uid : ''),
          username: userData.username || '',
          designation: userData.designation || '',
          grade: userData.grade || '',
          role_title: userData.role_title || '',
          personalEmail: userData.personalEmail || '',
          dateOfBirth: userData.dateOfBirth || '',
          nationality: userData.nationality || '',
          maritalStatus: userData.maritalStatus || '',
          currentAddress: userData.currentAddress || '',
          permanentAddress: userData.permanentAddress || '',
          emergencyContactName: userData.emergencyContactName || '',
          emergencyContactNumber: userData.emergencyContactNumber || '',
          profile_picture: userData.profile_picture || '',
          nicImageUrl: userData.nicImageUrl || '',
          certificateUrl: userData.certificateUrl || '',
          salarySlipUrl: userData.salarySlipUrl || '',
          // company: this.company.companyName,
          fullName: userData.username || '',
          status: userData.status || (this.$store.state.auth.user && this.$store.state.auth.user.status) || 'Active' // Preserve status
        };
        this.$store.commit('setUser', user);

      } catch (error) {
        console.error('Error fetching user from Firebase:', error);
        swal('Error', 'Failed to load user data: ' + error.message, 'error');
        this.user = defaultUserData;
        this.$router.push('/userManagement');
      } finally {
        this.isLoading = false;
        localStorage.removeItem('originalAdminUser');
      }
    },
    async checkResignedStatus() {
      try {
        const userId = this.$store.state.auth.user.uid;
        if (userId) {
          const userData = await firebase.readDatabase(`users/${userId}`);
          console.log('Firebase user data:', userData);
          if (userData && userData.status) {
            this.$store.commit("setUser", { ...this.$store.state.auth.user, status: userData.status });
          }
        }
      } catch (e) {
        console.error('Error checking Firebase status:', e);
      }
    },
    async logout() {
      try {
        await firebase.logout();
        unloadChatbot();

        this.$store.commit("clearAuth");

        this.$router.replace("/");
        localStorage.clear();
      } catch (e) {
        swal("Error!", e.message, "error");
      }
    },
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
<style>
.container {
  padding: 0px !important;
}
.resigned-banner {
  top: 0;
  z-index: 1000;
  width:100%;
  box-sizing: border-box
}
.navbar-nav.align-items-center .nav-item {
  display: flex;
  align-items: center;
}

.mobile-menu-dropdown {
  position: absolute;
  top: 45px;
  right: 2px;
  width: 220px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  z-index: 9999;
  overflow: visible;
}

.notif-bell {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  color: #64748b;
  transition: background 0.15s, color 0.15s;
}

.notif-bell:hover,
.notif-bell--active {
  background: #f1f5f9;
  color: #0f172a;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  border-bottom: 1px solid #f1f5f9;
}

.mobile-menu-item:last-child {
  border-bottom: none;
}

.mobile-menu-item:hover {
  /* background: #f8fafc; */
}

@media (max-width: 990px) {
  .mobile-icons {
    display: flex !important;
  }
}

@media (min-width: 990px) {
  .large-screen-text {
    display: flex !important;
  }
}

.mobile-menu-item i {
  width: 16px;
  color: #64748b;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue